/**
 * Navigation helper functions for consistent routing across the application
 */

/**
 * Generate the URL path to a supplier's profile page
 * @param supplierSlug - The unique slug identifier for the supplier
 * @returns The URL path to the supplier's profile page
 */
export const getSupplierProfileUrl = (supplierSlug: string): string => {
  return `/suppliers/${supplierSlug}`;
};

/**
 * Generate the URL path to a product's detail page
 * @param productSlug - The unique slug identifier for the product
 * @returns The URL path to the product's detail page
 */
export const getProductDetailUrl = (productSlug: string): string => {
  return `/product/${productSlug}`;
};

/**
 * Generate the URL path to a category page
 * @param categoryId - The unique identifier for the category
 * @returns The URL path to the category page
 */
export const getCategoryUrl = (categoryId: string): string => {
  return `/${categoryId}`;
};

/**
 * Generate the URL path to a subcategory page
 * @param categoryId - The unique identifier for the parent category
 * @param subCategoryId - The unique identifier for the subcategory
 * @returns The URL path to the subcategory page
 */
export const getSubcategoryUrl = (categoryId: string, subCategoryId: string): string => {
  return `/${categoryId}/${subCategoryId}`;
};

/**
 * Generate the URL path to a brand's page
 * @param brandSlug - The unique slug identifier for the brand
 * @returns The URL path to the brand's page
 */
export const getBrandUrl = (brandSlug: string): string => {
  return `/brands/slug/${brandSlug}`;
};
